.wrap { position: relative; width: 100%; }
.svg { display: block; width: 100%; overflow: visible; }
.grid { stroke: #eef0f3; stroke-width: 1; }
.axis { font-size: 10px; fill: var(--text-muted); }
.dot { cursor: pointer; }
.cursor { stroke: #9aa0a8; stroke-width: 1; }

.tip {
  position: absolute; z-index: 5; pointer-events: none;
  min-width: 168px; padding: 10px 12px;
  background: #fff; border-radius: 8px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.16);
}
.tipDate { font-size: 10px; font-weight: 600; letter-spacing: 0.04em; color: var(--text-muted); text-transform: uppercase; }
.tipRow { display: flex; align-items: center; gap: 8px; margin-top: 8px; font-size: 12px; }
.swatch { width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; }
.tipName { color: var(--text-value); flex: 1 0 auto; }
.tipVal { font-weight: 600; color: var(--text-title); margin-left: auto; }
.empty { padding: 48px 0; text-align: center; font-size: 13px; color: var(--text-muted); }
